import { TableColumn, Visit, worksheetStateField } from '../../core';
import { WorksheetIcon } from './coding-status';
import { FacilityWorksheetIcon } from './facility-status';
import React from 'react';
/*

1) If the universe of selected locations (when multi-select is enabled) only supports PHYSICIAN worksheet types, 
only display a single column in all visit lists representing profee worksheets.

2) If the universe of selected locations only supports InPatient and/or Outpatient, 
display a single column for worksheet states for Facility.

3) If the universe of selected locations support Physician and Inpatient and/or outpatient, 
display two columns of state icons in the visit list.

*/

type WorksheetTypes = 'PHYSICIAN' | 'INPATIENT' | 'OUTPATIENT';

const defaultStateColumn = {
  label: 'State',
  sort: true,
  render: (r: Visit) => WorksheetIcon(r.wsSummaries[0]),
  style: { width: 90 },
  data: worksheetStateField,
};


const inPatientColumn = {
  label: 'Facility',
  sort: true,
  render: (r: Visit) => (
    <FacilityWorksheetIcon
      {...r.wsSummaries.filter((v) => v.worksheetType === 'INPATIENT')[0]}
      visit={r}
    />
  ),
  style: { width: 80 },
  data: worksheetStateField,
};

const outPatientColumn = {
  label: 'Facility',
  sort: true,
  render: (r: Visit) => (
    <FacilityWorksheetIcon
      {...r.wsSummaries.filter((v) => v.worksheetType === 'OUTPATIENT')[0]}
      visit={r}
    />
  ),
  style: { width: 90 },
  data: worksheetStateField,
};

export function resolveStateColumns(types: string[], showFlags?: boolean): TableColumn[] {
  types.sort((a, b) => (a === 'PHYSICIAN' ? -1 : a.localeCompare(b)));

  const columns = [];
  types.forEach((a: WorksheetTypes) => {
    switch (a) {
      case 'PHYSICIAN':
        columns.push({
          label: 'Profee',
          sort: true,
          render: (r: Visit) => (
            <FacilityWorksheetIcon
              {...r.wsSummaries.filter((v) => v.worksheetType === 'PHYSICIAN')[0]}
              visit={r}
              hideFlags={showFlags}
            />
          ),
          style: { width: 90 },
          data: worksheetStateField,
        });
        break;
      case 'INPATIENT':
        columns.push(inPatientColumn);
        break;
      case 'OUTPATIENT':
        columns.push(outPatientColumn);
        break;
      default:
        columns.push(defaultStateColumn);
    }
  });

  if (!columns.length) {
    columns.push(defaultStateColumn);
  }

  return columns;
}
